// extracted by mini-css-extract-plugin
export default {"container":"HomePage_container__M-f19","heading":"HomePage_heading__3TeGV","link":"HomePage_link__ZALgu"};